import api from './api';
import tokenService from './tokenService';
import jwt_decode from 'jwt-decode';


export default {
    async login(accessToken: any): Promise<User> {

        // accessToken = tokenService.getToken();

        tokenService.saveToken(accessToken);

        // if (accessToken) {
        //  //  const { token } = { token: accessToken };
        // //   accessToken = token;
        // } else {
        //    accessToken = tokenService.getToken();
        // }

        const { 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name': name,
            chave_projeto, nome_projeto, idioma, url_base } = jwt_decode(accessToken) as TokenData;

        return {
            name,
            accessToken,
            chave_projeto,
            nome_projeto,
            idioma,
            url_base,
        };
    },
};

export interface AuthState {
    username: string | null;
    token: string | null;
    isLogged: boolean;
}

export interface User {
    name: string;
    accessToken: string;
    chave_projeto?: string;
    nome_projeto?: string;
    idioma: string;
    url_base?: string;
}

export interface TokenData {
    'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name': string;
    chave_projeto: string;
    nome_projeto: string;
    idioma: string;
    url_base: string;
}
